import Axios from '../axios.config'
import bus from "../components/bus"
import qs from "qs"

export default {
  state: {
    messageObj: {},
    messLenght: '',
    sendFrom: false,
    sendFromqTask: false,
    getTask: {
      name: "",
      types: "1",
      grouping: "",
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      hipping: 1,
      status: "1",
      week: []
    },
    data: [],
    templateId: 0,
    grouping: "0",
    groupings: [],
    clientNos: [],
    ids: [],
    ceEtId: 0,
    taskId: "",
    Cjiemu: false,
    playTimes: [],
    nodeId: 0,
    loading: false,//加载loading
    $router: null,
    folderId: '',
    ecId: "",
    treeNode: null,
    deTreeNode: null,
    iseditTask: false,
    type: "add",
    addEtpId: "",
    etIsLinkScreeen: true
  },
  mutations: {},
  actions: {
    getTaskDetails({state}, p) {
      state.loading = true
      Axios({
        url: "/etv/selectEquipmentTaskById.json",
        method: "POST",
        data: {'id': p},
        headers: {
          "contentType": "application/x-www-form-urlencoded"
        },
        transformRequest: [function (data) {
          if (data instanceof FormData) {
            return data
          }
          data = qs.stringify(data)
          return data
        }]
      }).then(res => {
        let code = res.data.code
        if (code === 0) {
          let arr = []
          state.messageObj = res.data.data

          if (state.messageObj.etIsLinkScreeen === undefined) {
            state.messageObj.etIsLinkScreeen = "1"
          }
          state.messLenght = "*(" + res.data.data.pmList.length + ")"
          state.getTask.name = res.data.data.etName
          state.getTask.types = res.data.data.etTaskType
          state.getTask.grouping = res.data.data.etEcId
          state.getTask.startDate = res.data.data.etStartDate
          state.getTask.endDate = res.data.data.etEndDate
          state.getTask.startTime = res.data.data.etStartTime
          state.getTask.endTime = res.data.data.etEndTime
          state.getTask.etIsLinkScreeen = res.data.data.etIsLinkScreeen
          if (state.messageObj.etIsLinkScreeen === "1") {
            state.etIsLinkScreeen = true
          } else {
            state.etIsLinkScreeen = false
          }
          if (eval(res.data.data.etFri)) {
            arr.push("五")
          }
          if (eval(res.data.data.etMon)) {
            arr.push("一")
          }
          if (eval(res.data.data.etSat)) {
            arr.push("六")
          }
          if (eval(res.data.data.etSun)) {
            arr.push("日")
          }
          if (eval(res.data.data.etThur)) {
            arr.push("四")
          }
          if (eval(res.data.data.etTue)) {
            arr.push("二")
          }
          if (eval(res.data.data.etWed)) {
            arr.push("三")
          }
          state.getTask.week = arr
        }
        state.loading = false
      })
    },

    sendModel1({state}) {
      state.getTask = {
        name: "",
        types: "1",
        grouping: "0",
        startTime: function () {
          var d = new Date()
          var year = d.getFullYear()
          var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
          var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
          var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
          var minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
          var second = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
          return [year, month, day].join('-') + " " + [hour, minute, second].join(':')
        }(),
        endTime: "",
        hipping: 1,
        status: "1",
        week: ["一", "二", "三", "四", "五", "六", "日"]
      }
      state.sendFrom = true

    },

    nextTask({state, dispatch}, data) {
      state.sendFromTask = false
      state.data = data
      dispatch('setSendaTask', data)
    },

    //获取任务列表
    async tdSetTree({state, dispatch}) {

      var zTree
      var t = $("#saoreLeft")
      let rMenu = $(".rMenu")

      let funcs = {
        RightClick: function (event, tree, treeNode) {

          state.addEtpId = treeNode.eid == undefined ? "" : treeNode.eid
          $(".curSelectedNode").removeClass("curSelectedNode")
          $(event.target).addClass("curSelectedNode")
          state.treeNode = treeNode
          if (!treeNode) {
            return
          }

          if (event.screenY) {

          }

          funcs.showRMenu(treeNode.layer, event.clientX, event.clientY, event.screenY, treeNode.eid)

        },
        showRMenu: function (type, x, y, y1, eid) {

          let H = $(document).height()
          rMenu.hide()

          if (eid == 1) {
            if (H - 120 - y1 <= $("#rMenu_new").height()) {
              y = y - $("#rMenu_new").height()
            }
            $("#rMenu_new").show()
          } else if (type == "one") {
            if (H - 120 - y1 <= $("#rMenu_one").height()) {
              y = y - $("#rMenu_one").height()
            }
            $("#rMenu_one").show()
          } else if (type == "two") {
            if (H - 120 - y1 <= $("#rMenu_tow").height()) {
              y = y - $("#rMenu_tow").height()
            }
            $("#rMenu_tow").show()
          } else if (type == "three") {
            if (H - 120 - y1 <= $("#rMenu_therr").height()) {
              y = y - $("#rMenu_therr").height()
            }
            $("#rMenu_therr").show()
          }

          rMenu.css({"top": y + "px", "left": x + "px", "visibility": "visible"}) //设置右键菜单的位置、可见
          $("body").bind("mousedown", funcs.BodyMouseDown)
        },
        BodyMouseDown: function (event) {
          if (!(event.target.id == "rMenu" || $(event.target).parents(".rMenu").length > 0)) {
            rMenu.css({"visibility": "hidden"})
          }
        },
        fuzzySearch: function (zTreeId, searchField, isHighLight, isExpand) {

          var zTreeObj = $.fn.zTree.getZTreeObj(zTreeId) //获取树对象
          if (!zTreeObj) {

          }
          var nameKey = zTreeObj.setting.data.key.name //获取name属性的key

          isHighLight = isHighLight === false ? false : true//除直接输入false的情况外,都默认为高亮
          isExpand = isExpand ? true : false
          zTreeObj.setting.view.nameIsHTML = isHighLight //允许在节点名称中使用html,用于处理高亮

          var metaChar = '[\\[\\]\\\\\^\\$\\.\\|\\?\\*\\+\\(\\)]' //js正则表达式元字符集
          var rexMeta = new RegExp(metaChar, 'gi') //匹配元字符的正则表达式

          // 过滤ztree显示数据
          function ztreeFilter(zTreeObj, _keywords, callBackFunc) {
            if (!_keywords) {
              _keywords = '' //如果为空，赋值空字符串
            }

            // 查找符合条件的叶子节点
            function filterFunc(node) {
              if (node && node.oldname && node.oldname.length > 0) {
                node[nameKey] = node.oldname //如果存在原始名称则恢复原始名称
              }
              //node.highlight = false; //取消高亮
              zTreeObj.updateNode(node) //更新节点让之前对节点所做的修改生效
              if (_keywords.length == 0) {
                //如果关键字为空,返回true,表示每个节点都显示
                zTreeObj.showNode(node)
                zTreeObj.expandNode(node, isExpand) //关键字为空时是否展开节点
                return true
              }
              //节点名称和关键字都用toLowerCase()做小写处理
              if (node[nameKey] && node[nameKey].toLowerCase().indexOf(_keywords.toLowerCase()) != -1) {
                if (isHighLight) { //如果高亮，对文字进行高亮处理
                  //创建一个新变量newKeywords,不影响_keywords在下一个节点使用
                  //对_keywords中的元字符进行处理,否则无法在replace中使用RegExp
                  var newKeywords = _keywords.replace(rexMeta, function (matchStr) {
                    //对元字符做转义处理
                    return '\\' + matchStr

                  })
                  node.oldname = node[nameKey] //缓存原有名称用于恢复
                  //为处理过元字符的_keywords创建正则表达式,全局且不分大小写
                  var rexGlobal = new RegExp(newKeywords, 'gi') //'g'代表全局匹配,'i'代表不区分大小写
                  //无法直接使用replace(/substr/g,replacement)方法,所以使用RegExp
                  node[nameKey] = node.oldname.replace(rexGlobal, function (originalText) {


                    return originalText
                  })
                  zTreeObj.updateNode(node) //update让更名和高亮生效
                }
                zTreeObj.showNode(node) //显示符合条件的节点
                return true //带有关键字的节点不隐藏
              }
              zTreeObj.hideNode(node) // 隐藏不符合要求的节点
              return false //不符合返回false
            }

            var nodesShow = zTreeObj.getNodesByFilter(filterFunc) //获取匹配关键字的节点
            processShowNodes(nodesShow, _keywords)//对获取的节点进行二次处理
          }

          /**
           * 对符合条件的节点做二次处理
           */
          function processShowNodes(nodesShow, _keywords) {
            if (nodesShow && nodesShow.length > 0) {
              //关键字不为空时对关键字节点的祖先节点进行二次处理
              if (_keywords.length > 0) {
                $.each(nodesShow, function (n, obj) {
                  var pathOfOne = obj.getPath() //向上追溯,获取节点的所有祖先节点(包括自己)
                  if (pathOfOne && pathOfOne.length > 0) {
                    // i < pathOfOne.length-1, 对节点本身不再操作
                    for (var i = 0; i < pathOfOne.length - 1; i++) {
                      zTreeObj.showNode(pathOfOne[i]) //显示节点
                      zTreeObj.expandNode(pathOfOne[i], true) //展开节点
                    }
                  }
                })
              } else { //关键字为空则显示所有节点, 此时展开根节点
                var rootNodes = zTreeObj.getNodesByParam('level', '0')//获得所有根节点
                $.each(rootNodes, function (n, obj) {
                  zTreeObj.expandNode(obj, true) //展开所有根节点
                })
              }
            }
          }

          //监听关键字input输入框文字变化事件
          $(searchField).bind('input propertychange', function () {
            function trim(str) { //删除左右两端的空格
              return str.replace(/(^\s*)|(\s*$)/g, "")
            }

            var _keywords = trim($(this).val())
            searchNodeLazy(_keywords) //调用延时处理
          })

          var timeoutId = null

          // 有输入后定时执行一次，如果上次的输入还没有被执行，那么就取消上一次的执行
          function searchNodeLazy(_keywords) {
            if (timeoutId) { //如果不为空,结束任务
              clearTimeout(timeoutId)
            }
            timeoutId = setTimeout(function () {
              ztreeFilter(zTreeObj, _keywords)   //延时执行筛选方法
              $(searchField).focus()//输入框重新获取焦点
            }, 100)
          }
        }
      }

      var setting = {
        async: {
          enable: true,
          url: "/etv/selectEqTaskCategoryAlls.json",
          autoParam: ["id=ecId"],
          headers: {
            token: localStorage.getItem("token1")
          },
          otherParam: {
            "ecId": function () {
              return state.ecId
            },
            "type": function () {
              return state.type
            }
          },
          dataFilter: filter,
        },
        view: {
          dblClickExpand: false,
          showLine: true,
          selectedMulti: false
        },
        data: {
          keep: {
            parent: true,
            leaf: true
          },
          simpleData: {
            enable: true,
            idKey: "id",
            pIdKey: "pId",
            rootPId: ""
          }
        },
        callback: {
          beforeClick: function (treeId, treeNode) {
            if (treeNode.ecType === "task") {
              bus.$emit("qiehuan")
            }
            state.treeNode = treeNode
            if (!treeNode.id) {
              return
            }
            $(".curSelectedNode").removeClass("curSelectedNode")
            state.folderId = treeNode.etEcId
            let p = treeNode.id
            state.taskId = treeNode.id
            state.ceEtId = treeNode.id
            if (isNaN(p)) {
              state.lid = p
              dispatch('getTaskDetails', p)
            }
          },
          //右键回调
          onRightClick: funcs.RightClick,
          //重命名回调
          beforeRename: function (treeId, treeNode, newName) {

            if (newName.length == 0) {
              bus.$elementMessage("节点名称不能为空", "error")
              return false
            }

            if (treeNode.eid) {
              Axios({
                url: "/etv/updateTaskCategory.json",
                method: "post",
                data: {
                  name: newName,
                  id: treeNode.eid
                },
                transformRequest: [function (data) {
                  if (data instanceof FormData) {
                    return data
                  }
                  data = qs.stringify(data)
                  return data
                }]
              }).then(res => {
                if (res.data.code == 0) {
                  bus.$elementMessage(bus.$t('tip.xgcg'), "success")
                } else if (res.data.code == 1) {
                  bus.$elementMessage(res.data.msg, "error")
                }
              })
            } else if (treeNode.id) {
              Axios({
                url: "/etv/updateETaskName.json",
                method: "post",
                data: {
                  etName: newName,
                  id: treeNode.id
                },
                transformRequest: [function (data) {
                  if (data instanceof FormData) {
                    return data
                  }
                  data = qs.stringify(data)
                  return data
                }]
              }).then(res => {
                if (res.data.code == 0) {
                  bus.$elementMessage(bus.$t('tip.xgcg'), "success")
                  dispatch('getTaskDetails', state.lid)
                } else if (res.data.code == 1) {

                  bus.$elementMessage(res.data.msg, "error")
                }
              })
            }
          }
        }
      }

      function filter(treeId, parentNode, childNodes) {

        if (childNodes.code === 401) {
          localStorage.removeItem("token1")
          bus.$router.push("/login")
        }
        if (parentNode) {

          let data = childNodes.data.children[0]

          if (state.type === "add") {
            data.ecType = "folder"
            data.layer = "two"
            data.icon = "/web/static/images/icon/folder.png"
            data.children = []
            data = JSON.stringify(data).replace(/EC_NAME/g, "name")
            return JSON.parse(data)
          }

          let p = data.id
          dispatch('getTaskDetails', p)

          if (data.type == 1) {
            data.icon = '/web/static/images/menu/tiHuan.png'
          } else if (data.type == 2) {
            data.icon = '/web/static/images/menu/zhuiJia.png'
          } else if (data.type == 3) {
            data.icon = '/web/static/images/menu/chaBo.png'
          } else if (data.type == 4) {
            data.icon = '/web/static/images/menu/sync.png'
          }

          data.parId = data.pId
          data.layer = "three"
          data.ecType = "task"

          return data

        } else {
          let data_new = JSON.parse(JSON.stringify(childNodes.data)
            .replace(/EC_NAME/g, "name"))
          data_new.name = bus.$t('task.task_list')
          data_new.open = true
          data_new.layer = "one"
          data_new.icon = "/web/static/images/icon/folder.png"
          data_new.pId = -1
          for (let i = 0; i < data_new.children.length; i++) {
            data_new.children[i].layer = "two"
            data_new.children[i].ecType = "folder"
            data_new.children[i].icon = "/web/static/images/icon/folder.png"
            data_new.children[i].pId = 0
            for (let j = 0; j < data_new.children[i].children.length; j++) {
              data_new.children[i].children[j].layer = "three"
              data_new.children[i].children[j].ecType = "task"
              if (data_new.children[i].children[j].type == 1) {
                data_new.children[i].children[j].icon = '/web/static/images/menu/tiHuan.png'
              } else if (data_new.children[i].children[j].type == 2) {
                data_new.children[i].children[j].icon = '/web/static/images/menu/zhuiJia.png'
              } else if (data_new.children[i].children[j].type == 3) {
                data_new.children[i].children[j].icon = '/web/static/images/menu/chaBo.png'
              }else if (data_new.children[i].children[j].type == 4) {
                data_new.children[i].children[j].icon = '/web/static/images/menu/sync.png'
              }
              data_new.children[i].children[j].parId = data_new.children[i].children[j].pId
            }
          }
          return data_new
        }
      }

      await function () {
        zTree = $.fn.zTree.init(t, setting)
        funcs.fuzzySearch("saoreLeft", "#searcha", null, true)
      }()
    },

    setSpid({state}, data) {
      state.getTask.grouping = data
    },

    refresh({state, dispatch}) {
      state.ecId = ""
      dispatch('tdSetTree')

    },

    //编辑局部刷新
    refreshParentNodeT({state}, data) {
      var zTree = $.fn.zTree.getZTreeObj("saoreLeft"),
        type = false,
        silent = "add"
      state.treeNode = zTree.getNodesByParam("eid", data[0])[0]
      if (data[1] !== "add") {
        state.deTreeNode = zTree.getNodesByParam("id", state.taskId)[0]
        zTree.removeNode(state.deTreeNode, false)
      }
      state.ecId = data[0]
      state.type = data[1]

      if (data[0] === -1) {
        state.treeNode = zTree.getNodesByParam("name", "任务列表")[0]
      } else {
        state.treeNode = zTree.getNodesByParam("eid", data[0])[0]
      }


      zTree.reAsyncChildNodes(state.treeNode, type, silent)
      if (!silent) zTree.selectNode(this.treeNode)
    },

    getfenzu({state}) {
      Axios({
        url: "/etv/selectEqTaskCategoryAll.json",
        methods: "POST",
      }).then(res => {
        state.groupings = res.data.data
      })
    }
  }
}








// WEBPACK FOOTER //
// ./src/store/task_store.js